module.exports = __webpack_public_path__ + "static/img/66c86c66b965f106865e58af52f1d0d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv1.jpg
// module id = QxAR
// module chunks = 1